export const assessments = {
  week1: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question: "What is the main idea behind compassion?",
        options: [
          { id: "A", text: "Observing without acting." },
          { id: "B", text: "Understanding feelings and providing help." },
          { id: "C", text: "Judging others based on their actions" },
          { id: "D", text: "Ignoring others' needs." },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "Which of the following best describes Compassionate Communication (NVC)?",
        options: [
          { id: "A", text: "A way to win arguments" },
          { id: "B", text: "A theory that explains evolution" },
          {
            id: "C",
            text: "A method to connect with others through compassionate expression",
          },
          { id: "D", text: "A strategy to avoid communication" },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question: "Which component of NVC involves expressing how you feel?",
        options: [
          { id: "A", text: "Observations." },
          { id: "B", text: "Feelings." },
          { id: "C", text: "Needs." },
          { id: "D", text: "Request." },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question: "Why is it important to practice compassion?",
        options: [
          { id: "A", text: "It helps us with friends." },
          {
            id: "B",
            text: "It creates stronger relationship and makes us feel valued",
          },
          { id: "C", text: "It helps us avoid conflicts" },
          { id: "D", text: "It makes us appear more popular" },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          'In the school scenario explained in the video, which step of NVC did the student use when they said, "I need some quiet time to complete my arguments?',
        options: [
          { id: "A", text: "Observation." },
          { id: "B", text: "Feeling." },
          { id: "C", text: "Need." },
          { id: "D", text: "Request." },
        ],
        correctOption: "D",
      },
    ],
  },
  week2: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question: "What does self-compassion mean?",
        options: [
          { id: "A", text: "Do nothing." },
          {
            id: "B",
            text: "Being kind and understanding towards yourself when things go wrong.",
          },
          { id: "C", text: "Comparing yourself to others" },
          { id: "D", text: "Being perfect in everything you do." },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question: "Which of the following is an example of self-compassion?",
        options: [
          { id: "A", text: "Criticizing yourself for every mistake." },
          { id: "B", text: "Pretending that your feelings does'nt exist." },
          { id: "C", text: "Speaking to yourself kindly when you fail." },
          { id: "D", text: "Blaming others for your problems." },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question: "Which of these is NOT a way to practice self-compassion?",
        options: [
          { id: "A", text: "Setting boundaries and saying no when needed." },
          {
            id: "B",
            text: "Engaging in positive self-talk when you make mistakes.",
          },
          {
            id: "C",
            text: "Ignoring your feelings and pretending everything is okay.",
          },
          {
            id: "D",
            text: "Practicing mindfulness by paying attention to your emotions.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 4,
        question:
          "What should you do when you find yourself being overly critical after making a mistake?",
        options: [
          { id: "A", text: "Keep criticizing yourself to improve." },
          { id: "B", text: "Continue thinking about the mistake." },
          {
            id: "C",
            text: "Treat yourself kindly, as you would treat a friend in the same situation.",
          },
          { id: "D", text: "Ask others to tell you what you did wrong." },
        ],
        correctOption: "C",
      },
      {
        id: 5,
        question: "Why is self-compassion important?",
        options: [
          { id: "A", text: "It helps us avoid all mistakes." },
          {
            id: "B",
            text: "It makes us feel better and helps us bounce back from challenges.",
          },
          { id: "C", text: "It allows us to be kind to others." },
          {
            id: "D",
            text: "It allows us to criticize ourselves in order to avoid further mistakes.",
          },
        ],
        correctOption: "B",
      },
    ],
  },
  week3: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "Can you identify the 3 key steps we learned about showing compassion for others as discussed in the lesson 'This will help you apply them in your daily life'?",
        options: [
          { id: "A", text: "Seeing, Ignoring, and Criticizing." },
          { id: "B", text: "Seeing, Caring, and Doing." },
          { id: "C", text: "Helping, Judging, and Complaining." },
          { id: "D", text: "Listening, Arguing, and Avoiding." },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "Which of the following is NOT a way of showing compassion to others?",
        options: [
          { id: "A", text: "Listening to a friend who is upset." },
          { id: "B", text: "Laughing at someone who made a mistake." },
          {
            id: "C",
            text: "Offering help to a classmate struggling with a project.",
          },
          { id: "D", text: "Giving a compliment to cheer someone up." },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question:
          "When practicing compassion for others, what is the first thing you should do?",
        options: [
          { id: "A", text: "Tell them what they did wrong." },
          { id: "B", text: "Notice when someone needs help." },
          { id: "C", text: "Ignore the situation and hope it improves." },
          { id: "D", text: "Immediately fix their problem." },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question: "Why is listening considered an act of compassion?",
        options: [
          { id: "A", text: "It makes you look good in front of others." },
          {
            id: "B",
            text: "It allows the person to feel heard and supported.",
          },
          { id: "C", text: "It distracts you from your own problems." },
          {
            id: "D",
            text: "It helps you get more information about someone's issues.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          "Which of the following is a compassionate response when a friend fails a test?",
        options: [
          { id: "A", text: '"It\'s your fault for not studying enough".' },
          {
            id: "B",
            text: "\"Everyone fails sometimes; it's okay. You'll do better next time.\"",
          },
          {
            id: "C",
            text: '"This test wasn\'t even hard; how could you fail?"',
          },
          {
            id: "D",
            text: "\"Let's just forget about it; it doesn't matter.\"",
          },
        ],
        correctOption: "B",
      },
    ],
  },
  week4: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question: "What is the Circle of Concern?",
        options: [
          { id: "A", text: "A way to decide which people to ignore." },
          {
            id: "B",
            text: "A concept that helps identify who is in your inner and outer circles.",
          },
          { id: "C", text: "A rule about how to be strict with strangers." },
          {
            id: "D",
            text: "A list of tasks to do for your friends and family.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question: "Who would be considered part of your inner circle?",
        options: [
          {
            id: "A",
            text: "A stranger you see every day on your way to school.",
          },
          { id: "B", text: "Your best friend." },
          { id: "C", text: "Your classmate whom you rarely talk to." },
          { id: "D", text: "A neighbor." },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question:
          "Which of the following actions would be more appropriate for your inner circle rather than your outer circle?",
        options: [
          { id: "A", text: "Smiling at someone you pass on the street." },
          { id: "B", text: "Listening to someone's personal problems." },
          { id: "C", text: "Greeting a classmate in the hallway." },
          { id: "D", text: "Offering to help a stranger carry groceries." },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question:
          "What should you consider when showing compassion to people in your outer circle?",
        options: [
          { id: "A", text: "Ignoring their needs." },
          { id: "B", text: "Being kind but keeping safe boundaries." },
          { id: "C", text: "Treating them the same as your family." },
          { id: "D", text: "Offering them everything you have." },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          "Which of the following is an action that can be appropriate for both inner and outer circles?",
        options: [
          { id: "A", text: "Sharing your personal secrets." },
          { id: "B", text: "Offering a smile or a compliment." },
          { id: "C", text: "Loaning money to a stranger." },
          { id: "D", text: "Inviting them into your home." },
        ],
        correctOption: "B",
      },
    ],
  },
  week5: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "Which of the following best represents the Compassionate Communication theory?",
        options: [
          {
            id: "A",
            text: "Observations, Criticism, Punishment, Demands.",
          },
          {
            id: "B",
            text: "Observations, Feelings, Needs, Requests.",
          },
          {
            id: "C",
            text: "Feelings, Demands, Arguments, Solutions.",
          },
          {
            id: "D",
            text: "Feelings, Judgments, Needs, Expectations.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "Why is it important to respect boundaries when showing compassion to people in your outer circle?",
        options: [
          {
            id: "A",
            text: "To avoid helping people at all.",
          },
          {
            id: "B",
            text: "To keep yourself safe while still being kind.",
          },
          {
            id: "C",
            text: "To prevent others from knowing how compassionate you are.",
          },
          {
            id: "D",
            text: "To avoid any communication with strangers.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question: "Scenario: Your friend failed a test while you scored the highest. How can you show compassion?",
        options: [
          {
            id: "A",
            text: "Brag about your high score and tell them they should have studied harder.",
          },
          {
            id: "B",
            text: "Encourage them by reminding them that one test doesn’t define their abilities and offer to help them study.",
          },
          {
            id: "C",
            text: "Ignore their feelings and celebrate your own success.",
          },
          {
            id: "D",
            text: "Tell them they should give up on the subject.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question: "Which statement best describes the ‘Circle of Concern’?",
        options: [
          {
            id: "A",
            text: "It’s a strategy for deciding who to be rude to.",
          },
          {
            id: "B",
            text: "It’s a method to identify who is in your inner and outer circles and how to act compassionately.",
          },
          {
            id: "C",
            text: "It’s a way to organize your friends based on how much you like them.",
          },
          {
            id: "D",
            text: "It’s a tool to exclude people from your life.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          "What is the most compassionate way to react when you notice someone being excluded or feeling left out?",
        options: [
          {
            id: "A",
            text: "Pretend you didn’t see anything.",
          },
          {
            id: "B",
            text: "Offer a kind gesture, like inviting them to join you.",
          },
          { id: "C", text: "Make a joke about the situation." },
          {
            id: "D",
            text: "Continue with what you’re doing without paying attention.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 6,
        question: "What is the first step when practicing compassionate communication?",
        options: [
          {
            id: "A",
            text: "Make a demand.",
          },
          { id: "B", text: "Identify the feelings involved." },
          { id: "C", text: "Observe the situation without judgment." },
          { id: "D", text: "Offer a solution immediately." },
        ],
        correctOption: "B",
      },
      {
        id: 7,
        question: "Why is it important to set boundaries when showing compassion?",
        options: [
          { id: "A", text: "To avoid showing compassion altogether." },
          { id: "B", text: "To protect yourself while still being kind." },
          { id: "C", text: "To keep people at a distance so they don’t bother you." },
          { id: "D", text: "To make others earn your compassion." },
        ],
        correctOption: "B",
      },
      {
        id: 8,
        question: "When someone in your outer circle asks for help, what should you consider first?",
        options: [
          { id: "A", text: "Whether they can do something for you in return." },
          {
            id: "B",
            text: "Your own boundaries and comfort level.",
          },
          {
            id: "C",
            text: "How you can ignore them without them noticing.",
          },
          {
            id: "D",
            text: "Whether others will think you are kind.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 9,
        question:
          "What should you do if a friend shares something personal and emotional with you?",
        options: [
          { id: "A", text: "Spread the information because it’s interesting." },
          {
            id: "B",
            text: "Listen attentively and offer support without judgment.",
          },
          {
            id: "C",
            text: "Change the subject to something more positive.",
          },
          { id: "D", text: "Criticize them for feeling that way." },
        ],
        correctOption: "B",
      },
      {
        id: 10,
        question:
          "Which behavior best reflects maintaining compassion while respecting your boundaries?",
        options: [
          {
            id: "A",
            text: "Offering help even if it makes you uncomfortable.",
          },
          {
            id: "B",
            text: "Being kind and supportive without overextending yourself.",
          },
          {
            id: "C",
            text: "Saying yes to everyone’s requests, no matter how you feel.",
          },
          {
            id: "D",
            text: "Avoiding all interactions to protect yourself.",
          },
        ],
        correctOption: "B",
      },
    ],
  },
};
